var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var sr=require("moment-timezone");module.exports=sr;